import React from 'react';
import { useParams } from 'react-router-dom';
import { getTeamPageContainer, getTeamConnectorConfig } from 'js/connectors';
import { Loading } from 'js/components';
import ConnectorTabEmptyState from './ConnectorTabEmptyState';

/**
 * Unified connector tab content: resolve container from route slug, check config,
 * show loading / not found / not configured / or render the connector container.
 * Used by both TeamConnectorReportContainer and TeamDashboardComponent.
 */
function ConnectorTabContent({
  team = null,
  teamConnectorConfigurations = [],
  teamConnectorConfigurationsHasLoaded = false,
}) {
  const { connectorId, connectorComponent } = useParams();
  const config = getTeamConnectorConfig(
    teamConnectorConfigurations,
    connectorId
  );
  const Container = getTeamPageContainer(connectorComponent);

  if (!Container) {
    return <ConnectorTabEmptyState team={team} variant="notFound" />;
  }

  if (!teamConnectorConfigurationsHasLoaded) {
    return <Loading />;
  }

  if (!config) {
    return <ConnectorTabEmptyState team={team} variant="notConfigured" />;
  }

  return (
    <Container
      team={team}
      teamConnectorConfigurations={teamConnectorConfigurations}
      teamConnectorConfigurationsHasLoaded={
        teamConnectorConfigurationsHasLoaded
      }
    />
  );
}

export default ConnectorTabContent;
